import { Users } from "lucide-react";
import { Tooltip } from "react-tooltip";

const COLORS = [
  "#133F7D",
  "#4A90D9",
  "#8880D0",
  "#7DD3E8",
  "#90B4E8",
  "#C5DAED",
  "#4EA8DE",
];

const CX = 140;
const CY = 140;
const OUTER_RADIUS = 118;
const RING_GAP = 16;
const STROKE_WIDTH = 10;

const ConcentricChart = ({ stats, maxValue }) => (
  <svg
    viewBox="0 0 280 280"
    width="45%"
    style={{ maxWidth: 260, display: "block", margin: "auto" }}
  >
    {stats.map((stat, i) => {
      const r = OUTER_RADIUS - i * RING_GAP;
      const circumference = 2 * Math.PI * r;
      const arcLength =
        maxValue > 0 ? (stat.value / maxValue) * circumference : 0;
      return (
        <g key={stat.label}>
          <circle
            cx={CX}
            cy={CY}
            r={r}
            fill="none"
            stroke="#e5e7eb"
            strokeWidth={STROKE_WIDTH}
          />
          <circle
            cx={CX}
            cy={CY}
            r={r}
            fill="none"
            stroke={stat.color}
            strokeWidth={STROKE_WIDTH}
            strokeDasharray={`${arcLength} ${circumference}`}
            strokeLinecap="round"
            transform={`rotate(-90 ${CX} ${CY})`}
          />
        </g>
      );
    })}
  </svg>
);

const L2ConversationofCandidates = ({ dashboardData }) => {
  const d = dashboardData?.l2ConversationofCandidates?.[0] || {};

  const stats = [
    {
      label: "Completed Interview",
      value: d.completedInterview || 0,
      color: COLORS[0],
    },
    {
      label: "Candidate Progressed(L1)",
      value: d.candidateProgressed || 0,
      color: COLORS[1],
    },
    { label: "L1 Rejected", value: d.l1Reject || 0, color: COLORS[2] },
    {
      label: "Candidate Declined",
      value: d.candidateDeclined || 0,
      color: COLORS[3],
    },
    {
      label: "Position on hold",
      value: d.positionOnHold || 0,
      color: COLORS[4],
    },
    {
      label: "Candidate on hold",
      value: d.candidateOnHold || 0,
      color: COLORS[5],
    },
    { label: "Not Advanced", value: d.notAdvanced || 0, color: COLORS[6] },
  ];

  const maxValue = Math.max(...stats.map((s) => s.value), 1);

  return (
    <div className="chart-container interview-analytics-container">
      <h3 className="chart-title">
        <Users style={{ color: "#0891B2" }} />
        L2 Conversation of Candidates
      </h3>

      <ConcentricChart stats={stats} maxValue={maxValue} />

      <div style={{ padding: "0 0px" }}>
        <div className="interview-analytics-legends p-3">
          <ul className="legend-list">
            {stats
              .slice(0, 4)
              .filter((v) => v.label !== "Completed Interview")
              .map((item, index) => (
                <li key={index} className="legend-item">
                  <div className="legend-label">
                    <div
                      className="legend-color"
                      style={{ backgroundColor: item.color }}
                    ></div>
                    <span
                      data-tooltip-id="interview-legend-tooltip"
                      data-tooltip-content={item.label}
                    >
                      {item.label}
                    </span>
                  </div>
                  <span className="legend-value">{item.value}</span>
                </li>
              ))}
          </ul>
          <ul className="legend-list">
            {stats
              .slice(4)
              .filter((v) => v.label !== "Completed Interview")
              .map((item, index) => (
                <li key={index} className="legend-item">
                  <div className="legend-label">
                    <div
                      className="legend-color"
                      style={{ backgroundColor: item.color }}
                    ></div>
                    <span
                      data-tooltip-id="interview-legend-tooltip"
                      data-tooltip-content={item.label}
                    >
                      {item.label}
                    </span>
                  </div>
                  <span className="legend-value">{item.value}</span>
                </li>
              ))}
          </ul>
          <Tooltip
            id="interview-legend-tooltip"
            place="top"
            style={{ padding: "4px 8px", fontSize: "12px", maxWidth: "260px" }}
          />
        </div>
      </div>
    </div>
  );
};

export default L2ConversationofCandidates;
